import {
  useQuery,
  type UseQueryOptions,
  type UseQueryResult,
} from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';

import { api } from '@/utils/api';
import { ApiErrorResponse, ApiResponse } from '@/types/api';

interface GetClientCheckRequest {
  email: string;
}

export interface GetClientCheckResponse {
  id: number;
  name: string;
  email: string;
}

export const getClientCheck = ({ email }: GetClientCheckRequest) => {
  return api.get<ApiResponse<GetClientCheckResponse>>('/client/check', {
    params: { email },
  });
};

const useClientCheck = <
  TData = AxiosResponse<ApiResponse<GetClientCheckResponse>>,
  TError = AxiosError<ApiErrorResponse>,
>(
  request: GetClientCheckRequest,
  options?: UseQueryOptions<
    AxiosResponse<ApiResponse<GetClientCheckResponse>>,
    TError,
    TData,
    ['getClientCheck', GetClientCheckRequest]
  >,
): UseQueryResult<TData, TError> => {
  return useQuery(['getClientCheck', request], () => getClientCheck(request), {
    ...options,
  });
};

export default useClientCheck;
